import {
  TextInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  required,
  maxLength,
  minValue,
  AutocompleteInput,
} from "react-admin";
import { Grid } from "@mui/material";
import CustomDateInput from "server/components/Fields/CustomDateInput";
import { administrationRequests } from "api/administrationApi";
import { specialistRequests } from "api/specialistApi";

const EditSaveForm = () => (
  <Grid
    container
    spacing={2}
  >
    <Grid
      item
      xs={12}
      md={6}
    >
      <ReferenceInput
        source="definitionId"
        reference={specialistRequests.getPostgraduateCourseDefinitionsSelect()}
        filter={{ filterByUser: true }}
      >
        <AutocompleteInput
          label="Определение на курс"
          optionText={rec => `${rec.name} | ${rec.typeNameBg} | ${rec.clinicNameBg}`}
          fullWidth
        />
      </ReferenceInput>
    </Grid>{" "}
    {/* to do: render definitionId or type, name and clinic */}
    <Grid
      item
      xs={12}
      md={6}
    >
      <TextInput
        source="name"
        label="Име"
        validate={[required(), maxLength(300)]}
        fullWidth
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <ReferenceInput
        source="typeId"
        reference={specialistRequests.getPostgraduateCourseTypesSelect()}
      >
        <SelectInput
          label="Тип"
          validate={[required()]}
          optionText={"nameBg"}
          fullWidth
        />
      </ReferenceInput>
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <ReferenceInput
        source="clinicId"
        reference={administrationRequests.getClinicsSelect()}
      >
        <SelectInput
          validate={[required()]}
          optionText="nameBg"
          label="Клиника"
          fullWidth
        />
      </ReferenceInput>
    </Grid>
    <Grid
      item
      xs={12}
    >
      <TextInput
        source="description"
        label="Описание"
        validate={[required(), maxLength(2000)]}
        minRows={5}
        maxRows={5}
        fullWidth
        multiline
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <ReferenceInput
        source="departmentId"
        reference={administrationRequests.getDepartmentsSelect()}
        filter={{ filterByUser: true }}
      >
        <SelectInput
          label="Катедра"
          validate={[required()]}
          fullWidth
        />
      </ReferenceInput>
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <NumberInput
        onWheel={e => e.target.blur()}
        source="durationInCalendarDays"
        label="Продължителност (дни)"
        validate={minValue(0)}
        fullWidth
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <CustomDateInput
        source="startDate"
        label="Начална дата"
        fullWidth
      />
    </Grid>
    <Grid
      item
      xs={12}
      md={6}
    >
      <NumberInput
        onWheel={e => e.target.blur()}
        source="maxParticipants"
        label="Максимален брой участници"
        defaultValue={0}
        validate={minValue(0)}
        fullWidth
      />
    </Grid>
    <Grid
      item
      xs={12}
    >
      <TextInput
        source="note"
        label="Бележка"
        validate={[maxLength(1000)]}
        minRows={5}
        maxRows={5}
        fullWidth
        multiline
      />
    </Grid>
  </Grid>
);

export default EditSaveForm;
